import { DashboardProviders } from "@dashboard/routes/DashboardProviders"
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import { dashboardAppHostRedirectUrl } from "@utils/dashboard-host"
import { currentRequestHostname } from "@utils/dashboard-host-runtime"

export const Route = createFileRoute("/dashboard")({
  component: DashboardLayoutRoute,
  beforeLoad: async ({ location }) => {
    const redirectHref = dashboardAppHostRedirectUrl(await currentRequestHostname(), location.href)
    if (redirectHref) throw redirect({ href: redirectHref })
  },
})

/**
 * Mounts the dashboard's providers once for every `/dashboard/*` page.
 *
 * Home and the sections are separate routes, and each used to mount its own
 * copy of the stack, so moving between them tore down the theme, the toast
 * host and the session gate and built them again — re-running the auth check
 * on a session that had not changed. This route stays mounted across all of
 * them, so now only the content below the Outlet swaps.
 *
 * The surfaces below still declare their own provider boundary, which becomes
 * a pass-through under this one. That keeps each renderable on its own, and
 * keeps the Contract Maker deployment working, since it has no layout route.
 */
function DashboardLayoutRoute() {
  return (
    <DashboardProviders>
      <Outlet />
    </DashboardProviders>
  )
}
